"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const MenuItem_1 = __importDefault(require("./MenuItem"));
const MenuWrapper = styled_components_1.default.div `
    background: #fff;
    height: 100%;
    font-size: 1rem;

    .Mui-selected{
       color: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.main : "#FFF")} ;
    }

    .MuiTabs-indicator{
      background-color: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.main : "#FFF")};

    }
`;
const LoaderWrapper = styled_components_1.default.div `
    position: relative;
    height: 100px;
`;
const ErrorWrapper = styled_components_1.default.div `
    text-align: center;
    padding: 20px;
`;
const MenuContentWrapper = styled_components_1.default.div `
    overflow: auto;
    display: flex;
    flex-direction: column;
`;
const MenuItemsWrapper = styled_components_1.default.div `
    overflow: auto;
    flex-basis: 90%;
    flex-grow: 1;
`;
const MenuItems = styled_components_1.default.div `
    margin: 16px 0 16px;
`;
const ViewBasketButton = styled_components_1.default.div `
    position: sticky;
    bottom: 0;
    width: 100%;
    background: #fff;
    padding: 16px;
    z-index: 10;
    text-align: center;
    width: calc( 100% + 32px );
    margin-left: -16px;
    border-top: 2px solid rgba(0,0,0,0.1);
`;
const Menu = (props) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [value, setValue] = (0, react_1.useState)(0);
    const [shoppingCartIsMandatory, setShoppingCartIsMandatory] = (0, react_1.useState)(false);
    const [texts, setTexts] = (0, react_1.useState)({ orderButtonLabel: "" });
    const [taxonomies, setTaxonomies] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)("");
    const { shoppingCartCatalogId, orderData, hideMenu, } = props;
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const renderTaxonomies = () => taxonomies.map((taxonomy) => (react_1.default.createElement(material_1.Tab, { key: taxonomy.id, label: taxonomy.name })));
    const handleMenuItemClick = (product) => {
        props.showProduct(product);
    };
    const renderMenuItems = () => taxonomies[value].products.map((product) => (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: product.id, onClick: () => handleMenuItemClick(product) },
        react_1.default.createElement(MenuItem_1.default, { data: product }))));
    const handleBasketButtonClick = () => {
        if (!shoppingCartIsMandatory || (orderData && orderData.order.lineItems.length > 0)) {
            hideMenu();
        }
    };
    const renderBasketButton = () => {
        if (!orderData || orderData.order.lineItems.length < 1) {
            return (react_1.default.createElement(ViewBasketButton, null,
                react_1.default.createElement(material_1.Button, { onClick: handleBasketButtonClick, variant: "contained", disabled: shoppingCartIsMandatory, type: "submit", fullWidth: true }, texts.orderButtonLabel)));
        }
        return (react_1.default.createElement(ViewBasketButton, null,
            react_1.default.createElement(material_1.Button, { onClick: handleBasketButtonClick, variant: "contained", disabled: isLoading || orderData.buttonDisabled, type: "submit", fullWidth: true }, orderData.texts.goToCartButton)));
    };
    const renderMenu = () => {
        if (isLoading) {
            return (react_1.default.createElement(LoaderWrapper, null,
                react_1.default.createElement(Loader_1.default, null)));
        }
        if (error) {
            return (react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" }, error));
        }
        return (react_1.default.createElement(MenuContentWrapper, { "data-testid": "menu", className: "menu-wrapper" },
            react_1.default.createElement(MenuItemsWrapper, { className: "redesign-menu" },
                react_1.default.createElement(material_1.Box, { sx: { borderBottom: 1, borderColor: "divider" } },
                    react_1.default.createElement(material_1.Tabs, { value: value, variant: "scrollable", scrollButtons: "auto", onChange: handleChange, "aria-label": "booking tabs" }, renderTaxonomies())),
                react_1.default.createElement(MenuItems, null,
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, renderMenuItems())))));
    };
    const getProducts = () => {
        apiService_1.default.getShoppingCartProducts(props.currentLocale, props.userData.token, shoppingCartCatalogId).then((data) => {
            if (data.status === "success" && data.taxonomies.length > 0) {
                setShoppingCartIsMandatory(data.shoppingCartIsMandatory);
                setTaxonomies(data.taxonomies);
                setTexts(data.texts);
            }
            else {
                setError(data.message ? data.message : i18n_js_1.default.t("no_items"));
            }
            setIsLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        if (shoppingCartCatalogId) {
            getProducts();
        }
        else {
            setIsLoading(false);
            setError("No shopping cart catalog id provided.");
        }
    }, []);
    return (react_1.default.createElement(MenuWrapper, { "data-testid": "menu-wrapper" },
        renderMenu(),
        !isLoading && renderBasketButton()));
};
exports.Menu = Menu;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.Menu);
